// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AirplaneIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.448 16.105 20 11.382V6a4 4 0 1 0-8 0v5.383l-9.447 4.722A1 1 0 0 0 2 17v4a1 1 0 0 0 1.196.98L12 20.22v2.366l-1.707 1.707A1.001 1.001 0 0 0 10 25v4a1 1 0 0 0 1.375.929L16 28.078l4.625 1.85A.999.999 0 0 0 22 29v-4a1 1 0 0 0-.293-.707L20 22.585V20.22l8.804 1.76A1 1 0 0 0 30 21v-4a1 1 0 0 0-.552-.895ZM28 19.78l-8.804-1.76A1 1 0 0 0 18 19v4a1 1 0 0 0 .293.707L20 25.415v2.108l-3.625-1.45a1 1 0 0 0-.742 0L12 27.521v-2.108l1.707-1.707A1.001 1.001 0 0 0 14 23v-4a1 1 0 0 0-1.196-.98L4 19.78v-2.163l9.447-4.722A1 1 0 0 0 14 12V6a2 2 0 1 1 4 0v6a1 1 0 0 0 .552.895L28 17.618v2.162Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
